/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router';

/* Import components */
import App from '@/App';
import { I18nProvider } from '@/context/I18nContext';

/* Import styles */
import '@/styles/tailwind.css';

/* Import own styles */
import '@/styles/main.scss';

declare global {
    interface Window {
        ENERGY_WATCHDOG_ROOT_ID?: string;
    }
}

const rootId = window.ENERGY_WATCHDOG_ROOT_ID ?? 'root';
const container = document.getElementById(rootId);

if (!container) {
    throw new Error(`Root container "#${rootId}" was not found.`);
}

ReactDOM.createRoot(container).render(
    <React.StrictMode>
        <I18nProvider>
            <HashRouter>
                <App />
            </HashRouter>
        </I18nProvider>
    </React.StrictMode>,
);
